
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parking/submit",
      function () {
        return require("private-next-pages/parking/submit.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parking/submit"])
      });
    }
  